import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { UserInfos } from '../types';

import { actionSlice } from './slices/action.slice';

import { AdminsSlice } from './slices/admins.slice';
import { AlQuranSlice } from './slices/al-quran.slice';
import { AzkaarSlice } from './slices/azkaar.slice';
import { CampangeSlice } from './slices/campange.slice';
import { ContactSlice } from './slices/contacts.slice';
import { ContentSlice } from './slices/content.slice';
import { CotisationSlice } from './slices/cotisation.slice';
import { KhassidaSlice } from './slices/khassida.slice';
import { loadngSlice } from './slices/loading.slice';
import { localeSlice } from './slices/local.slice';
import { PlaylistSlice } from './slices/playlist.slice';
import { SalatouSlice } from './slices/salatou.slice';
import { statusSlice } from './slices/status.slice';
import { userSlice } from './slices/user.slice';
import { UsersSlice } from './slices/users.slice';

const store = configureStore({
  reducer: {
    [actionSlice.name]: actionSlice.reducer,
    [statusSlice.name]: statusSlice.reducer,
    [loadngSlice.name]: loadngSlice.reducer,
    [localeSlice.name]: localeSlice.reducer,
    [userSlice.name]: userSlice.reducer,
    [UsersSlice.name]: UsersSlice.reducer,
    [KhassidaSlice.name]: KhassidaSlice.reducer,
    [PlaylistSlice.name]: PlaylistSlice.reducer,
    [SalatouSlice.name]: SalatouSlice.reducer,
    [CampangeSlice.name]: CampangeSlice.reducer,
    [CotisationSlice.name]: CotisationSlice.reducer,
    [AzkaarSlice.name]: AzkaarSlice.reducer,
    [AlQuranSlice.name]: AlQuranSlice.reducer,
    [ContentSlice.name]: ContentSlice.reducer,
    [AdminsSlice.name]: AdminsSlice.reducer,
    [ContactSlice.name]: ContactSlice.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>(); // Export a hook that can be reused to resolve types
export function useAppSelector<T>(cb: (root: RootState) => T) {
  return useSelector(cb);
}

export function useUser() {
  return useAppSelector((s) => s.auth.userInfos as UserInfos);
}
export default store;
